// removed by extract-text-webpack-plugin
module.exports = {"wrapper-text-format":"magazines_bvbpx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontFormat/styles.scss
// module id = 1116
// module chunks = 1